
import React from 'react';
import { Link } from 'react-router-dom';
import { NavItem } from './types';
import { useMobileNavigationItemHandlers } from './useMobileNavigationItemHandlers';

interface MobileNavigationLinkItemProps {
  item: NavItem;
  isActive: (href: string) => boolean;
  onClose: () => void;
  onNavigationClick?: (href: string) => void;
}

export const MobileNavigationLinkItem: React.FC<MobileNavigationLinkItemProps> = ({
  item,
  isActive,
  onClose,
  onNavigationClick
}) => {
  const { handleClick } = useMobileNavigationItemHandlers({
    onNavigationClick,
    onClose
  });

  // Safety check: ensure href exists
  if (!item.href) {
    console.error('MobileNavigationLinkItem received item without href:', item);
    return (
      <div className="block px-3 py-4 rounded-md text-lg font-semibold text-red-600 bg-red-50">
        Error: {item.label} (no href)
      </div>
    );
  }

  return (
    <Link
      to={item.href}
      onClick={(e) => handleClick(item.href, e)}
      className={`block px-3 py-4 rounded-md text-lg font-semibold transition-colors active:scale-95 ${
        isActive(item.href)
          ? 'text-blue-600 bg-blue-50'
          : 'text-gray-700 hover:text-blue-600 hover:bg-gray-100 active:bg-gray-200'
      }`}
      style={{ 
        minHeight: 48, 
        minWidth: 48, 
        touchAction: 'manipulation'
      }}
      role="menuitem"
      tabIndex={0}
      aria-current={isActive(item.href) ? "page" : undefined}
    >
      {item.label}
    </Link>
  );
};
